<template>
    <div class="accordion filter-form">

        <accordion-item
            class="mb-3 contrib-info"
            :expanded="params.info > 0"
            @expand="$emit('view', {info: ($event ? 1 : null)})"
        >
            <template v-slot:title>
                <!-- <svg xmlns="http://www.w3.org/2000/svg" style="width:1rem" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
                </svg> -->
                <span class="ms-2">{{ trans('contrib.title') }}</span>
            </template>
            <contribution-info :lang="lang"></contribution-info>
        </accordion-item>

        <div class="input-group mb-3">
            <input
                type="text"
                name="q"
                class="form-control search-field"
                :placeholder="trans('search.placeholder')"
                aria-label=""
                aria-describedby="f-search"
                :value="params.q"
                @input="updateSearch"
            />
            <button class="btn btn-outline-secondary" type="submit">
                <svg class="svg-inline--fa fa-search" style="width: 1rem" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
                </svg>
            </button>
        </div>

        <div class="input-group mb-1">
            <select
                class="form-select"
                id="f-inst-region"
                name="gs"
                aria-label=""
                v-model="params.state"
            >
                <option value="">{{ trans('states.all') }}</option>
                <option v-for="s in germanStates" :key="s.code" :value="s.code">
                    {{ s.name }}
                </option>
            </select>
        </div>

        <div class="card mb-1">
            <div class="card-body pt-2 pb-1">
                <div class="form-check form-switch">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="show-research"
                        name="bit"
                        value="research"
                        checked=""
                        v-model="params.bit"
                    >
                    <label class="form-check-label" for="show-research">
                        {{ trans('layers.research') }}
                    </label>
                </div>
                <div class="form-check form-switch">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="show-finance"
                        name="bit"
                        value="finance"
                        checked=""
                        v-model="params.bit"
                    >
                    <label class="form-check-label" for="show-finance">
                        {{ trans('layers.finance') }}
                    </label>
                </div>
            </div>
        </div>

        <div class="border rounded px-3 pt-1 pb-2 mb-1">
            <label class="btn-link" for="f-start-year">{{ trans('time.label') }}</label>
            <div class="d-flex">
                <select
                    class="form-select form-select-sm"
                    id="f-start-year"
                    name="ys"
                    aria-label="Start year"
                    v-model="params.ys"
                    :title="trans('time.start.year')"
                >
                    <option value=""></option>
                    <option v-for="y in years(2004, 'now')" :key="y" :value="y">{{ y }}</option>
                </select>
                <div class="mx-2 mt-1">-</div>
                <select
                    class="form-select form-select-sm"
                    id="f-end-year"
                    name="ye"
                    aria-label="End year"
                    v-model="params.ye"
                    :title="trans('time.end.year')"
                >
                    <option value=""></option>
                    <option v-for="y in years(2004, 2027)" :key="y" :value="y">{{ y }}</option>
                </select>
            </div>
        </div>

        <div class="accordion">

            <accordion-item ref="fieldSelect">
                <template v-slot:title>
                    <svg aria-hidden="true" focusable="false" class="svg-inline--fa fa-graduation-cap" style="width: 1rem" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"></path></svg>
                    <span class="ms-2">{{ category('research-fields').title[lang] }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(categoryCount('research-fields')) }}
                    </span>
                </template>
                <div v-for="t in category('research-fields').children" :key="t.id" class="form-check">
                    <label class="form-check-label">
                        <span
                            v-if="mode == 'geo-focus'"
                            class="d-inline-block me-1"
                            style="width: 0.5em; height: 80%"
                            :style="{background: categoryColors[t.id]}"
                        >
                            &nbsp;
                        </span>
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="params.t"
                            :value="t.id"
                        />
                        {{ t.title[lang] }}
                    </label>
                </div>
            </accordion-item>

            <accordion-item>
                <template v-slot:title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-square" viewBox="0 0 16 16">
                        <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"/>
                        <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                    </svg>
                    <span class="ms-2">{{ category('objectives').title[lang] }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(categoryCount('objectives')) }}
                    </span>
                </template>
                <ul class="list-unstyled">
                    <li v-for="t in category('objectives').children" :key="t.id">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    v-model="params.t"
                                    :value="t.id"
                                />
                                {{ t.title[lang] }}
                            </label>
                        </div>
                        <ul class="list-unstyled ps-4">
                            <li v-for="c in t.children" :key="c.id">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            v-model="params.t"
                                            :value="c.id"
                                            @change="select(t.id, $event.target.checked)"
                                        />
                                        {{ c.title[lang] }}
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </accordion-item>

            <accordion-item>
                <template v-slot:title>
                    <svg xmlns="http://www.w3.org/2000/svg" style="width:1rem" fill="currentColor" class="bi bi-tags" viewBox="0 0 16 16">
                        <path d="M3 2v4.586l7 7L14.586 9l-7-7H3zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2z"/>
                        <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1v5.086z"/>
                    </svg>
                    <span class="ms-2">{{ category('disciplines').title[lang] }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(categoryCount('disciplines')) }}
                    </span>
                </template>
                <div v-for="t in category('disciplines').children" :key="t.id" class="form-check">
                    <label class="form-check-label">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="params.t"
                            :value="t.id"
                        />
                        {{ t.title[lang] }}
                    </label>
                </div>
            </accordion-item>

            <accordion-item>
                <template v-slot:title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-card-text" viewBox="0 0 16 16">
                        <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                        <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>
                    </svg>
                    <span class="ms-2">{{ category('topics').title[lang] }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(categoryCount('topics')) }}
                    </span>
                </template>
                <div v-for="t in category('topics').children" :key="t.id" class="form-check">
                    <label class="form-check-label">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="params.t"
                            :value="t.id"
                        />
                        {{ t.title[lang] }}
                    </label>
                </div>
            </accordion-item>

            <accordion-item>
                <template v-slot:title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bar-chart" viewBox="0 0 16 16">
                        <path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z"/>
                    </svg>
                    <span class="ms-2">{{ category('methods').title[lang] }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(categoryCount('methods')) }}
                    </span>
                </template>
                <div v-for="t in category('methods').children" :key="t.id" class="form-check">
                    <label class="form-check-label">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="params.t"
                            :value="t.id"
                        />
                        {{ t.title[lang] }}
                    </label>
                </div>
            </accordion-item>

            <accordion-item v-if="mode == 'institutions'">
                <template v-slot:title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/>
                    </svg>
                    <span class="ms-2">{{ trans('regions.label') }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(params.r.length) }}
                    </span>
                </template>
                <div v-for="r in geoRegions" :key="r.id" class="form-check">
                    <label class="form-check-label">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="params.r"
                            :value="r.id"
                        />
                        {{ r.name[lang] }}
                    </label>
                </div>
            </accordion-item>

            <accordion-item>
                <template v-slot:title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bank" viewBox="0 0 16 16">
                        <path d="M8 .95 14.61 4h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.379l.5 2A.5.5 0 0 1 15.5 17H.5a.5.5 0 0 1-.485-.621l.5-2A.5.5 0 0 1 1 14V7H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 4h.89L8 .95zM3.776 4h8.447L8 2.05 3.776 4zM2 7v7h1V7H2zm2 0v7h2.5V7H4zm3.5 0v7h1V7h-1zm2 0v7H12V7H9.5zM13 7v7h1V7h-1zm2-1V5H1v1h14zm-.39 9H1.39l-.25 1h13.72l-.25-1z"/>
                    </svg>
                    <span class="ms-2">{{ trans('inst_types.label') }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(params.rit.length) }}
                    </span>
                </template>
                <div v-for="inst in institutions" :key="inst.key" class="form-check">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" v-model="params.rit" :value="inst.key" />
                        {{ inst[lang] }}
                    </label>
                </div>
            </accordion-item>

            <accordion-item>
                <template v-slot:title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-currency-euro" viewBox="0 0 16 16">
                        <path d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"/>
                    </svg>
                    <span class="ms-2">{{ trans('funding_entities.label') }}</span>
                    <span class="badge rounded-pill badge-dark ms-3">
                        {{ formatCount(params.funding.length) }}
                    </span>
                </template>
                <div v-for="e in financeEntities[lang]" :key="e.type" class="form-check">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" v-model="params.funding" :value="e.type" />
                        {{ e.label }}
                    </label>
                </div>
            </accordion-item>
        </div>

    </div>
</template>

<script>
import { debounce } from 'lodash'
import { trans } from './AppUtils'
import AccordionItem from './AccordionItem.vue'
import germanStates from './resources/german-states.json'
import instTypes from './resources/inst-types.json'
import financeEntities from './resources/finance-entities.json'
import geoRegions from './resources/geo-regions.json'
import ContributionInfo from './ContributionInfo.vue'


export default {
    components: {
        AccordionItem,
        ContributionInfo
    },

    emits: [
        "update",
        "view",
    ],

    props: {
        taxonomy: {
            type: Object,
            default: () => {},
        },
        query: {
            type: Object,
            default: () => ({}),
        },
        mode: {
            type: String,
            default: () => 'institutions'
        },
        focus: {
            type: Object,
            default: () => ({id: 0})
        }
    },

    data() {
        const params = this.query
        // console.debug("PARAMS", params)
        return {
            lang: document.documentElement.lang || 'de',
            info: (this.query.info > 0),
            params: params,
            germanStates: germanStates,
            institutions: instTypes,
            financeEntities: financeEntities,
            geoRegions: geoRegions,
            categoryColors: {
                '115': '#dfc27d',
                '116': '#beaed4',
                '117': '#fdc086',
                '118': '#7fc97f',
                '119': '#386cb0',
            }
        }
    },

    watch: {
        query: {
            deep: true,
            handler(query) {
                Object.assign(this.params, query)
            }
        },
        params: {
            deep: true,
            handler(model) {
                this.$emit("update", model)
            }
        },
        focus: {
            handler(focus) {
                this.$refs.fieldSelect.show()
            }
        }
    },

    methods: {

        trans,

        category(name) {
            return this.taxonomy[name] || {
                id: 0,
                name: name,
                title: '...',
                children: []
            }
        },

        select(id, checked) {
            // Also select the parent checkbox
        },

        years(start = 2004, end = 'now') {
            const years = []
            const now = (new Date()).getFullYear()
            const first = start
            const last = (end === 'now') ? now : end
            for (let y = first; y <= last; y++) {
                years.push(y)
            }
            return years
        },

        formatCount(count) {
            return (count > 0) ? count : ''
        },

        categoryCount(category) {
            let count = 0
            const selected = this.params.t
            const children = this.category(category).children

            for (const cat of children) {
                if (selected.includes(cat.id)) {
                    count++
                }
                for (const sub of cat.children || []) {
                    if (selected.includes(sub.id)) {
                        count++
                    }
                }
            }
            return count
        },

        updateSearch: debounce(
            function (ev) {
                const v = ev.target.value
                this.params.q = v
            },
            500
        ),

        debug(e) {
            console.debug(e)
        }
    }
}
</script>